// type-only import used for a documentation comment only.
// eslint-disable-next-line no-unused-vars
import type { useSearchParams } from "react-router-dom";

/**
 * Param values intended for use with {@link useSearchParams}.
 */
export const SearchParams = {
  /**
   * Dataset ID, repeatable. On the visualizer route, each value loads that
   * dataset as a workspace datasource.
   */
  DATASET: "dataset",

  /**
   * Event ID. On the visualizer route, opens the sidebar's event details
   * view for that event once the workspace loads.
   */
  EVENT: "event",

  /**
   * File ID, repeatable. On the visualizer route, each value loads that
   * file as a workspace datasource.
   */
  FILE: "file",

  /**
   * Saved-layout name. On the visualizer route, the loader opens the named
   * layout, and the workspace keeps the param in sync as the user activates
   * or discards saved layouts.
   */
  LAYOUT: "layout",

  /**
   * Session ID, repeatable. On the visualizer route, each value loads every
   * file in that session as a workspace datasource.
   */
  SESSION: "session",

  /**
   * Timestamp, intended to be encoded as fixed-point seconds with nanosecond precision.
   */
  TIMESTAMP: "t",
} as const;
